import React from 'react';
import PropTypes from 'prop-types';
import Prices from '@digital-retail/cross-prices';

const CrossPrice = ({ regionCode, priceList, discountBadge }) => {
  return <Prices priceList={priceList} regionCode={regionCode} discountBadge={discountBadge} />;
};

CrossPrice.propTypes = {
  priceList: PropTypes.arrayOf(PropTypes.object).isRequired,
  regionCode: PropTypes.string,
  discountBadge: PropTypes.object,
};

CrossPrice.defaultProps = {
  regionCode: 'cl',
  discountBadge: {},
};

export default CrossPrice;
export { CrossPrice };
